import { mapGetters } from 'vuex';
import mvtHotleadForm from '@/common/components/mvthotleadform/mvt-hotleadform.vue';

export default {
    name: 'valuationHotlead',
    inject: ['$eventBus'],
    components: {
        mvtHotleadForm,
    },
    data() {
        return {
            hotleadOpt: {
                hotleadType: 'HomeValueEstimate',
                buttonText: this.molang('dpp.hotleadForm.go'),
                showZipcode: true,
                hotleadSup: 'GET STARTED',
                hotleadTitle: 'Connect with an experienced agent',
                hideProfile:  true
            },
        };
    },
    computed: {
        ...mapGetters('glb', ['viewport', 'glb', 'getSplit']),
    },
};
